// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e5da9be6","453":"8e0aa4b0","455":"4fde6c5f","977":"e1dd249f"}[chunkId] + ".chunk.js";
};